// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  ExternalImportAdapterCollection,
  ExternalImportAdapterCollectionFromJSON,
  ExternalImportAdapterCollectionToJSON,
  ExternalImportCreateResult,
  ExternalImportCreateResultFromJSON,
  ExternalImportCreateResultToJSON,
  ExternalImportPayload,
  ExternalImportPayloadFromJSON,
  ExternalImportPayloadToJSON,
  ExternalImportSourceProjectCollection,
  ExternalImportSourceProjectCollectionFromJSON,
  ExternalImportSourceProjectCollectionToJSON,
  ExternalImportStatus,
  ExternalImportStatusFromJSON,
  ExternalImportStatusToJSON,
  ExternalImportTestConnectionPayload,
  ExternalImportTestConnectionPayloadFromJSON,
  ExternalImportTestConnectionPayloadToJSON,
  ExternalImportTestConnectionResult,
  ExternalImportTestConnectionResultFromJSON,
  ExternalImportTestConnectionResultToJSON,
  ExternalImportValidateSourceProjectPayload,
  ExternalImportValidateSourceProjectPayloadFromJSON,
  ExternalImportValidateSourceProjectPayloadToJSON,
  ExternalImportValidateSourceProjectResult,
  ExternalImportValidateSourceProjectResultFromJSON,
  ExternalImportValidateSourceProjectResultToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface CancelExternalImportRequest {
  id: number;
}

export interface CreateExternalImportRequest {
  externalImportPayload?: ExternalImportPayload;
}

export interface GetExternalImportStatusRequest {
  id: number;
}

export interface ListExternalImportProjectsRequest {
  type: string;
  project: number;
}

export interface TestExternalImportConnectionRequest {
  externalImportTestConnectionPayload?: ExternalImportTestConnectionPayload;
}

export interface ValidateExternalImportSourceProjectRequest {
  externalImportValidateSourceProjectPayload?: ExternalImportValidateSourceProjectPayload;
}

/**
 * no description
 */
export class ExternalImportsApi extends runtime.BaseAPI {
  /**
   * Marks the import for cancellation. The runner checks the cancellation flag between batches and stops cleanly. Already-imported entities are not rolled back; the customer must delete partial entities manually if they want to start over.
   * Cancel an in-progress external import
   */
  async cancelExternalImportRaw(
    requestParameters: CancelExternalImportRequest
  ): Promise<runtime.ApiResponse<ExternalImportStatus>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling cancelExternalImport."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/external-imports/{id}/cancel`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalImportStatusFromJSON(jsonValue)
    );
  }

  /**
   * Marks the import for cancellation. The runner checks the cancellation flag between batches and stops cleanly. Already-imported entities are not rolled back; the customer must delete partial entities manually if they want to start over.
   * Cancel an in-progress external import
   */
  async cancelExternalImport(
    requestParameters: CancelExternalImportRequest
  ): Promise<ExternalImportStatus> {
    const response = await this.cancelExternalImportRaw(requestParameters);
    return await response.value();
  }

  /**
   * Creates and queues an import job for the specified source-system project. Requires the externalImport_Run permission on the destination TestCollab project. Phase 1 blocks re-imports against the same source project; if a completed or in-progress import already exists, an error is returned.
   * Create and queue an external import job
   */
  async createExternalImportRaw(
    requestParameters: CreateExternalImportRequest
  ): Promise<runtime.ApiResponse<ExternalImportCreateResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/external-imports`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ExternalImportPayloadToJSON(
        requestParameters.externalImportPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalImportCreateResultFromJSON(jsonValue)
    );
  }

  /**
   * Creates and queues an import job for the specified source-system project. Requires the externalImport_Run permission on the destination TestCollab project. Phase 1 blocks re-imports against the same source project; if a completed or in-progress import already exists, an error is returned.
   * Create and queue an external import job
   */
  async createExternalImport(
    requestParameters: CreateExternalImportRequest
  ): Promise<ExternalImportCreateResult> {
    const response = await this.createExternalImportRaw(requestParameters);
    return await response.value();
  }

  /**
   * Returns a snapshot of the current status of an external import job, including stage, progress counts, per-type stats, throttle state and last activity. Frontend polls this every 2 seconds while the import is active and stops once status is done, failed, or cancelled.
   * Get external import status
   */
  async getExternalImportStatusRaw(
    requestParameters: GetExternalImportStatusRequest
  ): Promise<runtime.ApiResponse<ExternalImportStatus>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getExternalImportStatus."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/external-imports/{id}/status`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalImportStatusFromJSON(jsonValue)
    );
  }

  /**
   * Returns a snapshot of the current status of an external import job, including stage, progress counts, per-type stats, throttle state and last activity. Frontend polls this every 2 seconds while the import is active and stops once status is done, failed, or cancelled.
   * Get external import status
   */
  async getExternalImportStatus(
    requestParameters: GetExternalImportStatusRequest
  ): Promise<ExternalImportStatus> {
    const response = await this.getExternalImportStatusRaw(requestParameters);
    return await response.value();
  }

  /**
   * Returns the list of available integration adapters with their credential field schemas and option schemas. Drives the dynamic auth form on the frontend so adding a new adapter does not require frontend changes.
   * List available external import adapters
   */
  async listExternalImportAdaptersRaw(): Promise<
    runtime.ApiResponse<ExternalImportAdapterCollection>
  > {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/external-imports/adapters`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalImportAdapterCollectionFromJSON(jsonValue)
    );
  }

  /**
   * Returns the list of available integration adapters with their credential field schemas and option schemas. Drives the dynamic auth form on the frontend so adding a new adapter does not require frontend changes.
   * List available external import adapters
   */
  async listExternalImportAdapters(): Promise<ExternalImportAdapterCollection> {
    const response = await this.listExternalImportAdaptersRaw();
    return await response.value();
  }

  /**
   * Returns the list of projects available for import from the connected source system. Credentials must have been validated via the test-connection endpoint within the last 5 minutes (token cached server-side, keyed by user + import type).
   * List source-system projects available for import
   */
  async listExternalImportProjectsRaw(
    requestParameters: ListExternalImportProjectsRequest
  ): Promise<runtime.ApiResponse<ExternalImportSourceProjectCollection>> {
    if (
      requestParameters.type === null ||
      requestParameters.type === undefined
    ) {
      throw new runtime.RequiredError(
        "type",
        "Required parameter requestParameters.type was null or undefined when calling listExternalImportProjects."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling listExternalImportProjects."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.type !== undefined) {
      queryParameters["type"] = requestParameters.type;
    }

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/external-imports/projects`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalImportSourceProjectCollectionFromJSON(jsonValue)
    );
  }

  /**
   * Returns the list of projects available for import from the connected source system. Credentials must have been validated via the test-connection endpoint within the last 5 minutes (token cached server-side, keyed by user + import type).
   * List source-system projects available for import
   */
  async listExternalImportProjects(
    requestParameters: ListExternalImportProjectsRequest
  ): Promise<ExternalImportSourceProjectCollection> {
    const response = await this.listExternalImportProjectsRaw(
      requestParameters
    );
    return await response.value();
  }

  /**
   * Validates credentials against the source system without creating an import job. On success, the validated session is cached server-side (keyed by user + import_type) for 5 minutes so it can be reused by the project listing endpoint.
   * Validate external import credentials
   */
  async testExternalImportConnectionRaw(
    requestParameters: TestExternalImportConnectionRequest
  ): Promise<runtime.ApiResponse<ExternalImportTestConnectionResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/external-imports/test-connection`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ExternalImportTestConnectionPayloadToJSON(
        requestParameters.externalImportTestConnectionPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalImportTestConnectionResultFromJSON(jsonValue)
    );
  }

  /**
   * Validates credentials against the source system without creating an import job. On success, the validated session is cached server-side (keyed by user + import_type) for 5 minutes so it can be reused by the project listing endpoint.
   * Validate external import credentials
   */
  async testExternalImportConnection(
    requestParameters: TestExternalImportConnectionRequest
  ): Promise<ExternalImportTestConnectionResult> {
    const response = await this.testExternalImportConnectionRaw(
      requestParameters
    );
    return await response.value();
  }

  /**
   * Validates Jira credentials and a single Jira project key for the selected adapter, and returns metadata/counts for that one source project. This endpoint is used by the wizard flow that asks for a project key directly instead of loading all Jira projects.
   * Validate Jira project key for external import
   */
  async validateExternalImportSourceProjectRaw(
    requestParameters: ValidateExternalImportSourceProjectRequest
  ): Promise<runtime.ApiResponse<ExternalImportValidateSourceProjectResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/external-imports/validate-source-project`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ExternalImportValidateSourceProjectPayloadToJSON(
        requestParameters.externalImportValidateSourceProjectPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalImportValidateSourceProjectResultFromJSON(jsonValue)
    );
  }

  /**
   * Validates Jira credentials and a single Jira project key for the selected adapter, and returns metadata/counts for that one source project. This endpoint is used by the wizard flow that asks for a project key directly instead of loading all Jira projects.
   * Validate Jira project key for external import
   */
  async validateExternalImportSourceProject(
    requestParameters: ValidateExternalImportSourceProjectRequest
  ): Promise<ExternalImportValidateSourceProjectResult> {
    const response = await this.validateExternalImportSourceProjectRaw(
      requestParameters
    );
    return await response.value();
  }
}
